import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import FormCadastro from "../../forms/FormCadastroSindico";
import { cadastro, confirmarCodigoCadastro, reenviarCodigoCadastro } from "../../../actions/auth";
import { Card, Container, Icon, Transition } from "semantic-ui-react";
import { Link } from "react-router-dom";
// import Rodape from "../../layouts/Rodape";

const RECURSOS = [
  { icone: "check square outline", titulo: "Votações 100% online", texto: "Pautas, perguntas e documentos; cada morador vota pelo celular, de onde estiver." },
  { icone: "users", titulo: "Quórum em tempo real", texto: "Acompanhe quem já participou e gere relatórios em PDF." },
  { icone: "bell outline", titulo: "Avisos e chat moderado", texto: "Notifique os moradores e converse com eles dentro do app." },
  { icone: "file excel outline", titulo: "Cadastro sem esforço", texto: "Importe unidades e proprietários por planilha ou pela sua administradora." },
  { icone: "shield alternate", titulo: "Seguro de ponta a ponta", texto: "Acesso protegido, com verificação em duas etapas opcional." }
];

const Cadastro = (props) => {

  const submit = data => props.cadastro(data);

  return (
    <div>
      <MenuHorizontal activeItem={"Cadastro"} />
      <div className="ui-pagina-login">
        <div className="ui-pagina-login-gradient-img"></div>
        <Container>
          <div className="va-cad-layout">
          <aside className="va-cad-boasvindas">
            <span className="va-cad-selo">Bem-vindo ao Vote Assembleia</span>
            <h1>Sua assembleia, <br />sem burocracia.</h1>
            <p className="va-cad-sub">
              Crie sua conta em poucos minutos e comece a organizar votações para
              condomínios, sociedades e associações.
            </p>
            <ul className="va-cad-recursos">
              {RECURSOS.map(r => (
                <li key={r.titulo}>
                  <span className="va-cad-recurso-icone"><Icon name={r.icone} /></span>
                  <span><b>{r.titulo}</b><small>{r.texto}</small></span>
                </li>
              ))}
            </ul>
            <p className="va-cad-passos">
              <b>1</b> Seus dados <span>›</span> <b>2</b> Código no e-mail <span>›</span> <b>3</b> Pronto, você já entra
            </p>
          </aside>
          <Transition animation="fade down" duration={{ show: 1200, hide: 0 }} visible={true} transitionOnMount={true}>
            <Card fluid style={styles.card} className="card-auth">
              <Card.Content>
                <Card.Header style={styles.header}>
                  <img src="/images/logo-voteassembleia-com-escrita.png" alt="Vote Assembleia logo" height="64" style={{ marginBottom: "15px" }} />
                  <p className="ui-title">Cadastro do Administrador</p>
                </Card.Header>
              </Card.Content>
              <Card.Content>
                <FormCadastro
                  submit={submit}
                  confirmar={props.confirmarCodigoCadastro}
                  reenviar={props.reenviarCodigoCadastro}
                />
              </Card.Content>
              <Card.Content>
                <div style={styles.cardLink}>
                  <Link to="/login">Já tenho uma conta</Link>
                </div>
              </Card.Content>
            </Card>
          </Transition>
          </div>
        </Container>
        <p style={styles.copyright}>
          <a href="https://www.voteassembleia.com.br" className="rodape-link">VOTE ASSEMBLEIA</a> {new Date().getFullYear()}. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <Link to="/politica-de-privacidade" className="rodape-link">Política de Privacidade</Link>
        </p>
        <p style={styles.copyright}>
          © 2017 - {new Date().getFullYear()} APP4ALL TECNOLOGIA DA INFORMAÇÃO LTDA.
        </p>
      </div>
      {/* <Rodape /> */}
    </div>
  );
}

Cadastro.propTypes = {
  cadastro: PropTypes.func.isRequired,
  confirmarCodigoCadastro: PropTypes.func.isRequired,
  reenviarCodigoCadastro: PropTypes.func.isRequired
}

const styles = {
  card: {
    padding: "5px 15px 0px 15px",
    margin: "auto",
    marginTop: "0",
    marginBottom: "0",
    overflow: "hidden",
    maxWidth: "600px"
  },
  header: {
    padding: "10px 10px",
    textAlign: "center"
  },
  cardLink: {
    fontSize: "13px",
    color: "#2185e0",
    cursor: "pointer",
    textAlign: "center"
  },
  copyright: {
    maxWidth: "400px",
    padding: "10px 20px",
    fontSize: "8pt",
    textAlign: "center",
    fontFamily: "Geomanist",
    margin: "auto",
    marginTop: "-25px",
    color: "white",
    zIndex: 1,
    position: "relative",
    marginBottom: "15px"
  }
}

export default connect(null, { cadastro, confirmarCodigoCadastro, reenviarCodigoCadastro })(Cadastro);
